import React from 'react';
import SEO from '../components/SEO';
import '../styles/AboutUs.css';
import { Link } from 'react-router-dom';

const AboutUs = () => {
  return (
    <>
      <SEO page="aboutUs" />
      <div className="about-container">
        <section className="about-hero">
          <div className="hero-overlay"></div>
          <div className="hero-content">
            <h1>About Grizzly Tree Company</h1>
            <p>Professional Tree Care Services in Northern Nevada</p>
          </div>
        </section>

        <section className="company-intro">
          <div className="section-content">
            <div className="intro-text">
              <h2>Your Tree Care Experts</h2>
              <p>
                Founded by Nick Pedroza in Northern Nevada, Grizzly Tree Company serves the 
                communities of Reno, Gardnerville, and neighboring areas with expert tree care 
                services. Our journey began in the Tahoe region, where our passion for tree care 
                and maintenance was first cultivated. With roots deeply planted in the local 
                community, we've grown from a small operation into a trusted name in arboriculture 
                throughout the region. Today, we combine years of hands-on experience with a deep 
                understanding of local tree species to deliver exceptional arboricultural services.
              </p>
              <p>
                What sets us apart is our unique background in both traditional tree care and 
                wildland firefighting. This diverse experience has given us an unparalleled 
                understanding of forest health and fire mitigation practices. Our team's expertise 
                extends beyond basic tree maintenance to include comprehensive forest management, 
                hazard assessment, and ecological preservation techniques that are particularly 
                vital in our high-desert environment.
              </p>
            </div>
            <div className="intro-image">
              <img src="/images/team-working.jpg" alt="Grizzly Tree team at work" />
            </div>
          </div>
        </section>

        <section className="stats-section">
          <div className="stats-container">
            <div className="stat-item">
              <h3>20+</h3>
              <p>Years Combined Experience</p>
            </div>
            <div className="stat-item">
              <h3>4</h3>
              <p>Expert Team Members</p>
            </div>
            <div className="stat-item">
              <h3>100%</h3>
              <p>Satisfaction Guaranteed</p>
            </div>
            <div className="stat-item">
              <h3>Local</h3>
              <p>Nevada-Based Team</p>
            </div>
          </div>
        </section>

        <section className="services-overview">
          <div className="section-content">
            <h2>Our Expertise</h2>
            <div className="services-grid">
              <div className="service-card">
                <i className="fas fa-tree"></i>
                <h3>Tree Health Management</h3>
                <p>Comprehensive care and maintenance for all tree species</p>
              </div>
              <div className="service-card">
                <i className="fas fa-cut"></i>
                <h3>Professional Tree Care</h3>
                <p>Expert pruning, removal, and maintenance services</p>
              </div>
              <div className="service-card">
                <i className="fas fa-leaf"></i>
                <h3>Arborist Consultation</h3>
                <p>Expert advice on tree health and maintenance</p>
              </div>
              <div className="service-card">
                <i className="fas fa-users"></i>
                <h3>Experienced Team</h3>
                <p>From veteran hotshot crews to skilled climbers</p>
              </div>
            </div>
          </div>
        </section>

        <section className="team-highlight">
          <div className="section-content">
            <h2>Why Choose Grizzly Tree Company?</h2>
            <p>
              Our team brings together diverse expertise, from former wildland firefighters 
              to experienced arborists. Each member is hand-selected for their unique skills 
              and dedication to quality work. Led by owner Nick Pedroza, we tackle both large 
              and small-scale projects with the same commitment to excellence.
            </p>
            <p>
              What truly sets us apart is our comprehensive understanding of tree care in the 
              unique Northern Nevada climate. Our experience in wildland firefighting has given 
              us invaluable insights into fire prevention and forest health management. This 
              expertise is particularly crucial for property owners in our fire-prone region.
            </p>
            <p>
              We pride ourselves on our transparent communication, detailed assessments, and 
              customized care plans for every project. Our team is fully insured, professionally 
              trained, and committed to ongoing education in the latest arboricultural practices. 
              Whether you need routine maintenance, emergency services, or complex tree removal, 
              we have the knowledge, equipment, and experience to handle it safely and efficiently.
            </p>
            <p>
              Our focus remains steadfast on maintaining tree health and wellness in our community 
              while ensuring every job is done right the first time. We're not just service 
              providers – we're your neighbors and partners in maintaining the beauty and safety 
              of our local environment.
            </p>
          </div>
        </section>

        <section className="cta-section">
          <div className="cta-content">
            <h2>Ready to Work with Us?</h2>
            <p>Contact us today for expert tree care in Northern Nevada.</p>
            <Link to="/contact" className="cta-button">Get Free Estimate</Link>
          </div>
        </section>
      </div>
    </>
  );
};

export default AboutUs; 